import { EVariationTypes } from 'core/common/constants/multivariation'
import { TVariationField } from 'core/components/Multivariation/types'
import { IStoreValues, TVariationValues } from '../store'
import { getVariationByTypeAndValue, mapVariationValueToLabel } from '../utils'

export const getThirdVariationFields = (
  firstType: EVariationTypes,
  secondType: EVariationTypes,
  type: EVariationTypes,
  values: IStoreValues['variationValues']
): TVariationField[] =>
  Object.entries(values).reduce(
    (acc, [firstKey, firstValue]) => [
      ...acc,
      ...Object.entries(firstValue).reduce(
        (crr, [secondKey, secondValue]) => [
          ...crr,
          {
            name: `${firstKey}/${secondKey}`,
            variations: [
              mapVariationValueToLabel(firstType, getVariationByTypeAndValue(firstType, firstKey)),
              mapVariationValueToLabel(
                secondType,
                getVariationByTypeAndValue(secondType, secondKey)
              ),
            ],
            values: secondValue
              ? secondValue.map(item => getVariationByTypeAndValue(type, item))
              : [],
          },
        ],
        [] as TVariationField[]
      ),
    ],
    [] as TVariationField[]
  )

export const formatClearValues = (
  storeValues: IStoreValues['variationValues']
): IStoreValues['variationValues'] => {
  const keys = Object.keys(storeValues)
  const newValues = {} as IStoreValues['variationValues']
  keys.forEach(key => {
    const secondaryKeys = Object.keys(storeValues[key])
    const newItemValue = {} as TVariationValues<string[]>
    secondaryKeys.forEach(item => {
      newItemValue[item] = []
    })

    newValues[key] = newItemValue
  })

  return newValues
}
